import gql from 'graphql-tag';

export const createCoachingForm = gql`
  mutation CreateCoachingForm($input: CoachingFormInput) {
    createCoachingForm(input: $input)
  }
`;

export const updateDraftCoachingForm = gql`
  mutation UpdateDraftCoachingForm(
    $id: String!
    $input: CoachingFormInput
    $locale: String
    $emailFlag: Boolean
  ) {
    updateDraftCoachingForm(
      id: $id
      input: $input
      locale: $locale
      emailFlag: $emailFlag
    )
  }
`;
export const updateContactStatus = gql`
  mutation UpdateContactStatus($input: ContactStatusChangeInput!) {
    updateContactStatus(input: $input)
  }
`;

export const updateContactStatusNew = gql`
  mutation UpdateContactStatusNew($input: ContactStatusChangeInput!) {
    updateContactStatusNew(input: $input)
  }
`;
